/** Long-form date formatting (e.g. "January 1, 2026"). */

import { formatDateOnly } from "@forgepoint/shared";

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "long",
  day: "numeric",
  year: "numeric",
};

/**
 * Formats a `Date` in the long-form date style. An unparseable date formats as
 * "" rather than "Invalid Date", so a caller rendering a missing value shows
 * nothing (or its own placeholder) instead of browser wording.
 * @param date - The date to format
 * @returns The formatted date string, or "" when the date is invalid
 */
export function formatLongDate(date: Date): string {
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleDateString("en-US", DATE_FORMAT_OPTIONS);
}

/**
 * Formats a nullable date-only `YYYY-MM-DD` string in the long-form style.
 * @param value - A date-only string, or null when absent
 * @returns The formatted date, or "" when absent or invalid
 */
export function formatLongDateOnly(value: string | null): string {
  return formatDateOnly(value, DATE_FORMAT_OPTIONS, "en-US") ?? "";
}
